module.exports = __webpack_public_path__ + "static/media/pay-by-omise.08eb150e.png";